import React from 'react'

export class ShowWithDelay extends React.Component {
    constructor(props) {
        super(props);
        this.state = { number: "" };

 
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {


        setTimeout(
            function () 
            {
           
                this.state.number=this.props.number;
                this.setState({});

            }
                .bind(this),
            this.props.delay
        );



    }


    componentDidMount() {
        this.handleClick();
    }

    render() {

        return (
            <span >{traverse(this.state.number)}</span>
        )
    }
}

const persian = { 0: '۰', 1: '۱', 2: '۲', 3: '۳', 4: '۴', 5: '۵', 6: '۶', 7: '۷', 8: '۸', 9: '۹' };
function traverse(el) {
    el = el.toString();
    var list = el.match(/[0-9]/g);
    if (list != null && list.length !== 0) {
        for (var i = 0; i < list.length; i++)
            el = el.replace(list[i], persian[list[i]]);
    }
    return el;


}


// WEBPACK FOOTER //
// ./src/elements/ShowWithDelay.js